function makeButton (pName, pCollapsible = false) {
  const container = $('<div class="app-button">');
  const button = $('<div class="app-button-title">')
    .css({ display: 'flex', 'justify-content': 'space-between', 'align-items': 'center' })
    .append($('<div>').text(pName));

  container.append(button);

  if (pCollapsible) {
    button.append($('<span class="fal fa-chevron-down">'));
    container.append($('<div class="app-options">').css({ display: 'visible' }));
  }
  return container;
}

export { makeButton };
